import es from './translations/es';
import en from './translations/en';

const translations = { es, en };

export const getTranslations = (language) => {
  return translations[language] || translations.es;
};

export const SUPPORTED_LANGUAGES = [
  { code: 'es', label: 'ES', flag: '🇪🇸' },
  { code: 'en', label: 'EN', flag: '🇺🇸' },
];

export const DEFAULT_LANGUAGE = 'es';
